export enum TravellerCategory {
  unknown = 'unknown',
  adult = 'adult',
  youth = 'youth',
}
